export default {
    meg: {
        username: '姓名',
        email:'邮箱',
        home:'首页',
        news:'新闻资讯',
        introduction:'平台介绍',
        Product:'ODM产品展示',
        news:'新闻资讯',
        factory:'平台工厂',
        Entering:'走进汇智衣',
        person:'个人中心',
        welcome:'欢迎',
        logoout:'退出登录',
        login:'登录｜注册',
        userlogin:'用户登录',
        userName:'请输入用户名/邮箱',
        Password:'请输入密码',
        forgotpassword:'忘记密码',
        loginBtn:'立即登录',
        resgister:'注册账户',
        progress:'注册汇智衣账户以便下单和追踪您的订单，查看订单进度等',
        customer:'客户注册',
        manufacturer:'生产商注册',
        resgisteruser:'我是已注册用户，前往',
        logBtn:'登录',
        user:'用户名',
        tephone:'手机号',
        password:'密码',
        confirmPassword:'重复密码',
        code:'邮箱验证码',
        contacts:'联系人',
        newproduct:'新品',
        viewProduct:'查看更多产品',
        viewDetail:'查看详情',
        positioning:'平台定位',
        resources:'资源的整合',
        urgent:'HZY-汇智衣服装制造全流程服务平台(以下简称“HZY平台”)是一家专注承接小单、急单，提供生产管理、生产监控、订单交付一体化服务的服装智能生产互联网平台。',
        driven:'资源的驱动',
        manufacturing:'HZY平台旨在利用云计算、大数据、Al智能、物联网等新一代信息技术，整合、驱动订单资源和产能资源，为国内外纺织服装生产制造新需求注入新动力、开创新模式。',
        operation:'平台运营模式',
        intelligent:'以全流程服务平台+MRIs 5G智能制造系统打造',
        application:'汇智衣订单管理、生产、监控一体化服务及应用平台',
        process:'平台运行流程-下单方',
        Services:'平台服务',
        Efficient:'高效',
        small:'小单、急单高效匹配平行工厂',
        ratio:'高性价比',
        cost:'小单、急单生产成本性价比高',
        monitoring:'实时监控',
        visualization:'订单生产期实时可视生产现场',
        solutions:'平台解决方案',
        MRIssystem:'MRIs系统',
        developed:'是平台自主研发的全新的服装生产组织管理系统，用于支撑“HZY平台”旗下各平行工厂专注承楼小单、急单进行快速智能生产。',
        unit:'MRIs系统以每位员工为生产单元，根据订单需求，智能生成即时生产线，快速完成各订单服装生产的过程。使订单制造加工过程更加便捷、标准、透明。',
        Industrial:'山东汇智衣工业科技有限公司',
        Internet:'山东汇智衣工业科技有限公司是一家专注于服装制造领域技术进步与产业升级的服装行业的工业互联网公司。',
        research:'山东汇智衣工业科技有限公司以AI智能科技的工业化应用研发为先导，集合深厚的服装生产制造资源与经验，开发并推广拥有完全自我知识产权的“MRIs服装生产管理系统”，并融合长期积淀的国内外服装贸易资源，搭建“HZY-汇智衣服装制造全流程服务平台”，在全面创新服装生产制造生产组织和管理模式的基础上，力促服装行业全新运行模式和产业格局的形成。',
        Clothing:'MRIs服装生产管理系统',
        Full:'HZY-汇智衣服装制造全流程服务平台',
        perfectly:'山东汇智衣工业科技有限公司下辖之“HZY-汇智衣服装制造全流程服务平台”以全新的电子贸易模式实现了全球服装制造订单和中小型服装制造企业产能的集合衔接，并以“MRIs服装生产管理系统”实现服装制造端产能的标准化与智能化，以全新科技手段使服装加工产业链运行的可控性和灵活性得以完美的结合，服装制造订单流转的如期率、质保率和安全性得到了前所未有的保障和提升。',
        future:'山东汇智衣工业科技有限公司以科技为力量全面契合服装制造行业“小批量多品种”、“小单快返”、“多款并行”的行业发展趋势，以全新的行业思维和开放的行业视野，寻求行业发展新动力，拓展行业未来新格局。',
        order:'下单',
        inlet:'入口',
        fac:'工厂',
        ACCOUNT:'我的账户',
        personal:'个人资料',
        myOrder:'我的订单',
        MyCollection:'我的收藏',
        identity:'您还未认证，请尽快认证身份',
        Certified:'认证客户',
        Certifieman:'认证生产商',
        Review:'等待审核',
        Company:'企业/个人名称',
        address:'地址',
        Establishment:'成立时间',
        Number:'员工数量',
        Business:'经营类型',
        ProductType:'产品品类',
        saleType:'销售类型',
        distribution:'销售渠道',
        annual:'年销售量',
        revenue:'年销售额',
        processing:'期望加工方式',
        markets:'主要市场',
        Profile:'企业/个人简介',
        license:'营业执照',
        uploaded:'只能上传jpg/png文件',
        Applying:'申请认证',
        upload:'点击上传',
        plantArea:'厂房面积',
        lines:'产线数量',
        category:'加工品类',
        output:'年产量',
        value:'年产值',
        orderType:'接单类型',
        facImg:'工厂图片',
        ImproveInformation:'完善信息',
        back:'返回',
        Ordering:'订单信息',
        CustomerName:'客户名称',
        contactsInformation:'联系方式',
        CustomerType:'客户类型',
        ordertt:'订单类型',
        productiontype:'生产类型',
        producttype:'产品类型',
        isseason:'季节类型',
        processtype:'加工类型',
        pictures:'款式图',
        preparation:'制单文件',
        view:'查看',
        contract:'合同',
        PDF:'只能上传一个pdf文件,包含面辅料说明、工艺说明、尺寸表、重点说明等',
        total:'订单数量',
        totals:'总数',
        color:'颜色',
        size:'尺码',
        quantity:'总数',
        deletecolor:'删除颜色',
        addcolor:'新增颜色',
        DeliveryInfo:'交付信息',
        arrivaltime:'物料到厂时间',
        orderNum:'订单编号',
        deliveryType:'交货类型',
        shippingtime:'出货时间',
        destination:'交货目的地',
        advance:'预付款',
        Payment:'货款计算方式',
        shipment:'出货款',
        balance:'尾款',
        period:'账期',
        points:'开票及税点',
        general:'普票税点',
        special:'专票税点',
        settlement:'结算方式',
        shipping:'出货方式',
        price:'意向目标价',
        submit:'提交',
        productName:'产品名称',
        loginPage:'返回首页',
        viewFactory:'查看更多工厂',
        cutNum:'裁剪人数',
        sewing:'缝制人数',
        packaging:'包装人数',
        quality:'质检人数',
        contact:'业务联系人',
        Position:'业务联系人职务',
        information:'业务人联系方式',
        contactPhone:'联系人电话',
        ContactEmail:'联系人邮箱',
        ContactWeChat:'联系人微信',
        ContactQQ:'联系人QQ',
        Registration:'注册信息',
        Changepassword:'修改密码',
        confimChange:'确认修改',
        cancel:'取消',
        orderList:'订单列别',
        LetterIntent:'意向单',
        whole:'全部',
        Toproduced:'待生产',
        Production:'生产中',
        finished:'已完成',
        Detail:'查看详情',
        Serial:'序号',
        Operation:'操作',
        receiveOrder:'接单',
        prog:'查看进度',
        collect:'收藏列表',
        Cancelcollect:'取消收藏',
        today:'今日日期',
        DeliveryDate:'交货日期',
        remark:'备注',
        feedback:'生产进度反馈',
        message:'消息通知',
        messageList:'消息列表',
        status:'状态',
        search:'搜索',
        reset:'重置',
        read:'已读',
        unread:'未读',
        markRead:'标记已读',
        hzy:'汇智衣',
        Inspection:'验货方式',
        money:'货币种类',
        Trendy:'汇智能制造制天下潮衣',
        surface:'面辅料说明',
        specialProcess:'特殊工艺说明',
        follow:'关注我们'
    }
}